import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { handleShowModal } from 'components/global/_helpers/global.helpers';
import PageTitle from 'components/global/PageTitle/PageTitle';
import SignalTable from 'components/global/SignalTable/SignalTable';
import SimpleCard from 'components/global/SimpleCard';
import InvestorPortfolioAddModal from 'components/views/InvestorPortfolioList/_components/InvestorPortfolioAddModal';
import InvestorPortfolioDeleteModal from 'components/views/InvestorPortfolioList/_components/InvestorPortfolioDeleteModal';
import InvestorPortfolioEditModal from 'components/views/InvestorPortfolioList/_components/InvestorPortfolioEditModal';
import InvestorPortfolioHighlights from 'components/views/InvestorPortfolioList/_components/InvestorPortfolioHighlights';
import InvestorPortfolioListRow from 'components/views/InvestorPortfolioList/_components/InvestorPortfolioListRow';
import { fetchAndSetTeamsOptions, fetchAndSetPortfolioData } from 'components/views/InvestorPortfolioList/_helpers/investorPortfolioList.resolvers';
import withDismount from 'hocs/withDismount';
import { Button } from 'react-bootstrap';
import { $filter, $list, $view } from 'signals/global.signals';
import useEffectAsync from 'utils/useEffectAsync';

const InvestorPortfolioList = () => {
  useEffectAsync(async () => {
    await fetchAndSetPortfolioData();
    await fetchAndSetTeamsOptions();
  });

  return (
    <>
      <PageTitle Buttons={(
        <Button
          onClick={() => handleShowModal('investor-portfolio-add')}
          variant="dark"
          className="text-white border-dark"
        >
          <FontAwesomeIcon icon={faPlus} className="me-8" />
          Add Portfolio
        </Button>
      )}
      >
        Portfolio
      </PageTitle>
      <SimpleCard>
        <InvestorPortfolioHighlights />
        <SignalTable
          headers={[
            { value: 'Company Name', key: 'companyName' },
            { value: 'Team', key: 'team' },
            { value: '% Owned', key: 'holdingsPct' },
            { value: 'Holdings Value', key: 'holdingsValue' },
            { value: 'Annual Revenue', key: 'arr' },
            { value: 'Stage', key: 'investmentStage' },
            { value: 'Valuation', key: 'currentValuation' },
            { value: 'Actions', key: 'Actions' },
          ]}
          rows={InvestorPortfolioListRow({ data: $list.value.data || [] })}
          $view={$view}
          $filter={$filter}
        />
      </SimpleCard>
      <InvestorPortfolioAddModal />
      <InvestorPortfolioEditModal />
      <InvestorPortfolioDeleteModal />
    </>
  );
};

export default withDismount(InvestorPortfolioList);
